import { View, Text, ImageBackground, Pressable } from 'react-native'
import React, { useLayoutEffect, useState } from 'react'
import { useNavigation } from '@react-navigation/native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import DropDownPicker from 'react-native-dropdown-picker';
import alert from './../alert'
import GlobalStyles from './../style';
import { useSelector } from 'react-redux'
import dr from './../datosReferenciales.json'
import transl from './../translations/transl'

let lang = undefined;

const AssignBroom = ({route}) => {
    const navigation = useNavigation();
    useLayoutEffect(() => {
      navigation.setOptions({
          headerShown: true,
          headerTitle: transl('Roster.asignarEscoba', lang)
      })
    }, []);

    const data = route.params != null ? JSON.parse(route.params) : null
    let myPlayers = []
    let brooms = []
    if(data !== undefined && data) {
      for(let i = 0; i < data.teams[0].players.length; i++){
        myPlayers[i] = {
          label: data.teams[0].players[i].name,
          value: i
        }  
      }
      for(let i = 0; i < data.others.brooms.length; i++){
        brooms[i] = {
          label: data.others.brooms[i].name,
          value: i
        }
      }
    }

    lang = dr.idiomas[useSelector((state) => state.language)].value
  
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState(null);
    const [items, setItems] = useState(myPlayers);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [open2, setOpen2] = useState(false);
    const [value2, setValue2] = useState(null);
    const [items2, setItems2] = useState(brooms);
    const [selectedIndex2, setSelectedIndex2] = useState(null);

  return (
    <View style={{height:'100%'}}>
      <ImageBackground source={require('./../img/witchesBrooms.png')} resizeMode="cover" style={{flex:1}}>
        <View style={{flex:1, justifyContent:'center'}}>
          <View>
            <View style={{marginHorizontal:'auto'}}>
                <Text style={{textAlign:'center',fontWeight:'bold',fontSize:22}}>{transl('AssignBroom.eligeUnJugador', lang)}</Text>
            </View>
            <View style={{marginTop:25, marginHorizontal:25}}>
                <DropDownPicker
                    open={open}
                    value={value}
                    items={items}
                    setOpen={setOpen}
                    setValue={setValue}
                    setItems={setItems}
                    onSelectItem={(item) => setSelectedIndex(item.value)}
                    zIndex={2000}
                    placeholder={transl('General.seleccionaJugador', lang)}
                    selectedItemContainerStyle={{
                      backgroundColor: "#cccccc"
                    }}
                    selectedItemLabelStyle={{
                      backgroundColor: "#cccccc"
                    }}
                    autoScroll={true}
                />
                <DropDownPicker
                    open={open2}
                    value={value2}
                    items={items2}
                    setOpen={setOpen2}
                    setValue={setValue2}
                    setItems={setItems2}
                    dropDownContainerStyle={{
                        marginTop:15
                    }}
                    zIndex={1000}
                    placeholder={transl('General.seleccionaEscoba', lang)}
                    style={{marginTop:15}}
                    onSelectItem={(item) => setSelectedIndex2(item.value)}
                    selectedItemContainerStyle={{
                      backgroundColor: "#cccccc"
                    }}
                    selectedItemLabelStyle={{
                      backgroundColor: "#cccccc"
                    }}
                    autoScroll={true}
                    ListEmptyComponent={() => (
                      <Text style={{ textAlign: 'center', padding: 10 }}>
                        {transl('Objects.sinEscobas')}
                      </Text>
                    )}
                />
                <View style={{marginBottom:15, marginTop:15, marginHorizontal:25,zIndex:0}}>
                  <Pressable
                  disabled={value == null || value2 == null}
                  style={
                    (value == null || value2 == null) ? GlobalStyles.buttonMainDisabled : GlobalStyles.buttonMain
                  }
                  onPress={() => {assign(data,selectedIndex,selectedIndex2,navigation)}}>
                  <Text style={GlobalStyles.textForButtonMain}>{transl('AssignBroom.asignarEscoba', lang)}</Text>
                </Pressable>
              </View>
            </View>
          </View>
        </View>
      </ImageBackground>
    </View>
  )
}

function assign(data,ssi,ssi2,navigation) {
  if(ssi2 == null || ssi == null){
    alert(transl('General.info', lang),"Debes escoger jugador y escoba",[{text: transl('General.OK', lang),onPress: () => void(0),style: "cancel"}])
    return
  }
  if(data === undefined || !data) return;

  data.teams[0].players[ssi].broom = [
    data.others.brooms[ssi2].velocidad,
    data.others.brooms[ssi2].maniobra,
    data.others.brooms[ssi2].estabilidad
  ]

  const broomName = data.others.brooms[ssi2].name

  data.others.brooms.splice(ssi2,1)
  saveData(data,broomName,data.teams[0].players[ssi].name,navigation)
}

function saveData(data,broom,player,navigation){
  const text = transl('AssignBroom.escobaAsignada', lang, [broom,player])
  const storeData = async (data) => {
    try {
      const jsonValue = JSON.stringify(data)
      await AsyncStorage.setItem('equipos', jsonValue)
      alert(transl('General.info', lang),text,[{text: transl('General.OK', lang),onPress: () => void(0),style: "cancel"}])
      navigation.navigate('HomeScreen')
    } catch (e) {
      console.log("error saving file")
      console.log(e)
    }
  }

  storeData(data);
}

export default AssignBroom